import type { ReactNode } from 'react';
import { memo } from 'react';
import type { IconNames } from 'components/mui/common/Icon';
import type { CustomButtonProps } from './CustomButton.tsx';
import { CustomButton } from './CustomButton.tsx';

export interface SaveButtonProps extends CustomButtonProps {
  onClick: () => void;
  children: ReactNode;
  disabled?: boolean;
  startIcon?: IconNames;
  endIcon?: IconNames;
  dataTestId?: string;
}

export const SaveButton = memo((props: SaveButtonProps) => {
  return (
    <CustomButton {...props} startIcon="Save" dataTestId={props.dataTestId ?? 'table-save-button'}>
      {props.children}
    </CustomButton>
  );
});
